import { BeneficiaryVisibilityType } from "@/modules/beneficiary/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";

export const getBeneficiaryTabItems = ({ t }: ITabItemsProps) => [
  {
    value: BeneficiaryVisibilityType.Private,
    label: t("beneficiary.owned"),
    dataId: "beneficiary-owned-tab",
    disabled: false,
  },
  {
    value: BeneficiaryVisibilityType.Shared,
    label: t("beneficiary.shared"),
    dataId: "beneficiary-shared-tab",
    disabled: false,
  }];
